import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

import Card from "../../Card/Card";
import Container from "../../Container/Container";
import IconBox from "../../IconBox/IconBox";
import SectionTitle from "../../SectionTitle/SectionTitle";
import { fadeUp, staggerContainer, viewportOnce } from "../../../Utils/animations";
import { getIcon } from "../../../Utils/iconMap";
import { services } from "../../../Data/servicesData";

import "../../../Style/home/services.css";

/** Six services mapped from servicesData.js — nothing hardcoded per card. */
function Services() {
  const handleRedirect = (link) => (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation(); // <-- Prevents event bubbling to parent Card
    }
    if (!link) return;

    // Guard: Don't push to history if already on this path
    if (window.location.pathname === link) return;

    if (link.startsWith("/")) {
      window.history.pushState({}, "", link);
      window.dispatchEvent(new Event("popstate"));
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      window.location.href = link;
    }
  };

  return (
    <section id="services" className="section section--tint services">
      <Container>
        <SectionTitle
          eyebrow="What We Do"
          title="Solutions built around"
          highlight="your growth."
          description="Every engagement starts with your data and your goals — the services below are the building blocks we combine to hit them."
        />

        <motion.div
          className="card-grid card-grid--3"
          variants={staggerContainer(0.08)}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
        >
          {services.map((service) => (
            <Card
              key={service.id}
              interactive
              gradientBorder
              variants={fadeUp()}
              className="service-card"
              onClick={handleRedirect(service.link)}
              style={{ cursor: "pointer" }}
            >
              <IconBox icon={getIcon(service.icon)} />
              <h3 className="card__title mt-5">{service.title}</h3>
              <p className="card__text">{service.description}</p>

              <a
                href={service.link}
                className="link-arrow service-card__link"
                onClick={handleRedirect(service.link)}
              >
                Learn More <ArrowUpRight size={16} />
              </a>
            </Card>
          ))}
        </motion.div>
      </Container>
    </section>
  );
}

export default Services;